import React from "react";
import {
    Box,
    Container,
    Grid,
    Typography,
    IconButton,
    Link,
} from "@mui/material";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import GitHubIcon from "@mui/icons-material/GitHub";
import TwitterIcon from "@mui/icons-material/Twitter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";

const footerLinks = {
    product: {
        title: "产品服务",
        links: [
            { label: "深度搜索", href: "#features" },
            { label: "文档分享", href: "#features" },
            { label: "识字学习", href: "#features" },
            { label: "创作收益", href: "#features" },
        ],
    },
    support: {
        title: "帮助支持",
        links: [
            { label: "使用指南", href: "#" },
            { label: "常见问题", href: "#" },
            { label: "意见反馈", href: "#" },
            { label: "版本更新", href: "#" },
        ],
    },
    about: {
        title: "关于我们",
        links: [
            { label: "公司介绍", href: "#about" },
            { label: "联系我们", href: "#about" },
            { label: "加入我们", href: "#" },
            { label: "合作伙伴", href: "#" },
        ],
    },
    legal: {
        title: "法律条款",
        links: [
            { label: "用户协议", href: "#" },
            { label: "隐私政策", href: "#" },
            { label: "版权声明", href: "#" },
            { label: "文库规则", href: "#" },
        ],
    },
};

function Footer() {
    const currentYear = new Date().getFullYear();

    return (
        <Box
            component="footer"
            sx={{
                background: "linear-gradient(180deg, #0f172a 0%, #1e293b 100%)",
                color: "#ffffff",
                pt: 10,
                pb: 5,
                position: "relative",
                overflow: "hidden",
            }}
        >
            {/* 顶部渐变分隔线 */}
            <Box
                sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    height: 2,
                    background:
                        "linear-gradient(90deg, transparent 0%, #00d4ff 30%, #7c3aed 70%, transparent 100%)",
                }}
            />

            {/* 背景装饰光晕 */}
            <Box
                sx={{
                    position: "absolute",
                    top: "10%",
                    left: "-5%",
                    width: 300,
                    height: 300,
                    borderRadius: "50%",
                    background:
                        "radial-gradient(circle, rgba(0, 212, 255, 0.08) 0%, transparent 70%)",
                    pointerEvents: "none",
                }}
            />
            <Box
                sx={{
                    position: "absolute",
                    bottom: "20%",
                    right: "-5%",
                    width: 350,
                    height: 350,
                    borderRadius: "50%",
                    background:
                        "radial-gradient(circle, rgba(124, 58, 237, 0.08) 0%, transparent 70%)",
                    pointerEvents: "none",
                }}
            />

            <Container maxWidth="lg" sx={{ position: "relative", zIndex: 1 }}>
                <Grid container spacing={5}>
                    {/* 品牌区域 */}
                    <Grid item xs={12} md={4}>
                        <Box sx={{ mb: 4 }}>
                            {/* Logo */}
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1.5,
                                    mb: 3,
                                }}
                            >
                                <Box
                                    sx={{
                                        width: 50,
                                        height: 50,
                                        borderRadius: "14px",
                                        background:
                                            "linear-gradient(135deg, #00d4ff 0%, #7c3aed 100%)",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        boxShadow:
                                            "0 4px 20px rgba(0, 212, 255, 0.25)",
                                    }}
                                >
                                    <AutoStoriesIcon
                                        sx={{ fontSize: 28, color: "#ffffff" }}
                                    />
                                </Box>
                                <Typography
                                    variant="h5"
                                    sx={{
                                        fontWeight: 800,
                                        background:
                                            "linear-gradient(135deg, #00d4ff 0%, #7c3aed 100%)",
                                        WebkitBackgroundClip: "text",
                                        WebkitTextFillColor: "transparent",
                                        letterSpacing: "-0.02em",
                                    }}
                                >
                                    知嘛
                                </Typography>
                            </Box>

                            {/* 品牌描述 */}
                            <Typography
                                sx={{
                                    color: "#cbd5e1",
                                    lineHeight: 1.9,
                                    mb: 4,
                                    maxWidth: 340,
                                    fontSize: "0.95rem",
                                }}
                            >
                                知嘛是一款AI驱动的智能知识库小程序，致力于为用户提供高效的知识搜索、文档分享和学习体验。让知识触手可及，让学习更加轻松。
                            </Typography>
                        </Box>

                        {/* 联系信息 */}
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 2.5,
                            }}
                        >
                            {[
                                {
                                    icon: <EmailIcon sx={{ fontSize: 18 }} />,
                                    text: "support@xinzhiwenku.com",
                                },
                                {
                                    icon: <PhoneIcon sx={{ fontSize: 18 }} />,
                                    text: "400-888-8888",
                                },
                                {
                                    icon: (
                                        <LocationOnIcon sx={{ fontSize: 18 }} />
                                    ),
                                    text: "广东省广州市天河区",
                                },
                            ].map((item, index) => (
                                <Box
                                    key={index}
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 1.5,
                                        transition: "all 0.3s ease",
                                        "&:hover": {
                                            "& .contact-icon": {
                                                background:
                                                    "linear-gradient(135deg, #00d4ff 0%, #7c3aed 100%)",
                                                color: "#ffffff",
                                            },
                                            "& .contact-text": {
                                                color: "#ffffff",
                                            },
                                        },
                                    }}
                                >
                                    <Box
                                        className="contact-icon"
                                        sx={{
                                            width: 38,
                                            height: 38,
                                            borderRadius: "10px",
                                            background:
                                                "rgba(255, 255, 255, 0.08)",
                                            border: "1px solid rgba(255, 255, 255, 0.1)",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            color: "#00d4ff",
                                            transition: "all 0.3s ease",
                                        }}
                                    >
                                        {item.icon}
                                    </Box>
                                    <Typography
                                        className="contact-text"
                                        sx={{
                                            color: "#e2e8f0",
                                            fontSize: "0.9rem",
                                            transition: "color 0.3s ease",
                                        }}
                                    >
                                        {item.text}
                                    </Typography>
                                </Box>
                            ))}
                        </Box>
                    </Grid>

                    {/* 链接区域 */}
                    {Object.entries(footerLinks).map(([key, section]) => (
                        <Grid item xs={6} sm={3} md={2} key={key}>
                            <Typography
                                sx={{
                                    fontWeight: 700,
                                    mb: 3,
                                    color: "#ffffff",
                                    fontSize: "1.05rem",
                                    position: "relative",
                                    display: "inline-block",
                                    "&::after": {
                                        content: '""',
                                        position: "absolute",
                                        bottom: -8,
                                        left: 0,
                                        width: 24,
                                        height: 2,
                                        background:
                                            "linear-gradient(90deg, #00d4ff 0%, #7c3aed 100%)",
                                        borderRadius: 1,
                                    },
                                }}
                            >
                                {section.title}
                            </Typography>
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 1.5,
                                    mt: 4,
                                }}
                            >
                                {section.links.map((link) => (
                                    <Link
                                        key={link.label}
                                        href={link.href}
                                        underline="none"
                                        sx={{
                                            color: "#94a3b8",
                                            fontSize: "0.9rem",
                                            transition: "all 0.3s ease",
                                            display: "inline-flex",
                                            alignItems: "center",
                                            "&:hover": {
                                                color: "#00d4ff",
                                                paddingLeft: "8px",
                                            },
                                            "&::before": {
                                                content: '""',
                                                width: 0,
                                                height: 1,
                                                backgroundColor: "#00d4ff",
                                                marginRight: 0,
                                                transition: "all 0.3s ease",
                                            },
                                            "&:hover::before": {
                                                width: 12,
                                                marginRight: 8,
                                            },
                                        }}
                                    >
                                        {link.label}
                                    </Link>
                                ))}
                            </Box>
                        </Grid>
                    ))}
                </Grid>

                {/* 分隔线 */}
                <Box
                    sx={{
                        my: 5,
                        height: 1,
                        background:
                            "linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.15) 20%, rgba(255, 255, 255, 0.15) 80%, transparent 100%)",
                    }}
                />

                {/* 底部区域 */}
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: { xs: "column", md: "row" },
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: 3,
                    }}
                >
                    <Typography
                        sx={{
                            color: "#94a3b8",
                            fontSize: "0.875rem",
                            textAlign: { xs: "center", md: "left" },
                        }}
                    >
                        © {currentYear} 新知文库. All rights reserved.
                        <Box component="span" sx={{ mx: 1.5, opacity: 0.5 }}>
                            |
                        </Box>
                        <Link
                            href="https://beian.miit.gov.cn/"
                            target="_blank"
                            rel="noopener noreferrer"
                            underline="none"
                            sx={{
                                color: "#94a3b8",
                                transition: "color 0.3s ease",
                                "&:hover": { color: "#00d4ff" },
                            }}
                        >
                            滇ICP备2026004514号-1
                        </Link>
                        <Box component="span" sx={{ mx: 1.5, opacity: 0.5 }}>
                            |
                        </Box>
                        <Link
                            href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=53030202000583"
                            target="_blank"
                            rel="noopener noreferrer"
                            underline="none"
                            sx={{
                                color: "#94a3b8",
                                transition: "color 0.3s ease",
                                display: "inline-flex",
                                alignItems: "center",
                                gap: 0.5,
                                "&:hover": { color: "#00d4ff" },
                            }}
                        >
                            <Box
                                component="img"
                                src="/beian.png"
                                alt="公安备案"
                                sx={{ width: 16, height: 16 }}
                                onError={(e) => {
                                    e.target.style.display = "none";
                                }}
                            />
                            滇公网安备53030202000583号
                        </Link>
                    </Typography>

                    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                        <Typography
                            sx={{
                                color: "#94a3b8",
                                fontSize: "0.875rem",
                                mr: 1,
                            }}
                        >
                            关注我们
                        </Typography>
                        {[
                            { icon: <GitHubIcon />, label: "GitHub" },
                            { icon: <TwitterIcon />, label: "Twitter" },
                            { icon: <LinkedInIcon />, label: "LinkedIn" },
                        ].map((social, index) => (
                            <IconButton
                                key={index}
                                size="small"
                                aria-label={social.label}
                                sx={{
                                    width: 42,
                                    height: 42,
                                    borderRadius: "12px",
                                    color: "#94a3b8",
                                    background: "rgba(255, 255, 255, 0.05)",
                                    border: "1px solid rgba(255, 255, 255, 0.1)",
                                    transition: "all 0.3s ease",
                                    "&:hover": {
                                        color: "#ffffff",
                                        background:
                                            "linear-gradient(135deg, #00d4ff 0%, #7c3aed 100%)",
                                        borderColor: "transparent",
                                        transform: "translateY(-4px)",
                                        boxShadow:
                                            "0 8px 20px rgba(0, 212, 255, 0.3)",
                                    },
                                }}
                            >
                                {social.icon}
                            </IconButton>
                        ))}
                    </Box>
                </Box>
            </Container>
        </Box>
    );
}

export default Footer;
